import { Button, Card, DatePicker, Form, Icon, Input, Modal, Select, Spin, Table, Tooltip } from 'antd';
import React from "react";
import { isArray, sanitizeFieldName } from "../../util/methods";
import FieldSearchForm from "../../components/FieldSearchForm";
import * as moment from 'moment';
import axios from 'util/Api';

class Create extends React.Component {

  spareSearchRequestSeq = 0;

  constructor(props) {
    super(props);
    this.state = {
      keys: [],
      location: '',
      locationId: null,
      jobCardSelected: true,
      subLocations: [],
      currentIndex: '',
      selectedSpares: {},
      spareSearchResults: [],
      balancePopup: { visible: false, loading: false, rows: [] },
    }
  }

  componentDidMount() {
    const { match, fetch, title } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    const { data: { spares = [{}] } } = this.props;

    // Initialize selected spares from existing data
    const selectedSpares = {};
    if (spares && spares.length) {
      spares.forEach((entry, index) => {
        if (entry && entry.spareName) {
          const spareId = entry.spareName._id || entry.spareName;
          selectedSpares[index] = spareId;
        }
      });
    }

    this.setState({
      keys: spares,
      selectedSpares,
    });
    this.props.getLocationByQuery();
    this.props.getAllUOM();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.spares && JSON.stringify(nextProps.data.spares) !== JSON.stringify(this.props.data.spares)) {
      // Re-initialize selected spares when data changes
      const selectedSpares = {};
      if (nextProps.data.spares && nextProps.data.spares.length) {
        nextProps.data.spares.forEach((entry, index) => {
          if (entry && entry.spareName) {
            const spareId = entry.spareName._id || entry.spareName;
            selectedSpares[index] = spareId;
          }
        });
      }

      this.setState({
        keys: nextProps.data.spares,
        selectedSpares,
      });
    }
    // if (nextProps.spareQty) {
    //   const qtyData = [...this.state.subLocations];
    //   qtyData.push(nextProps.spareQty);
    //   this.setState({
    //     subLocations: qtyData,
    //   });
    // }

    // below removed by jay
    // if(nextProps.spareQty) {
    //   const qtyData = [...this.state.subLocations];
    //   console.log(qtyData, nextProps.spareQty);
    //   qtyData[this.state.currentIndex] = nextProps.spareQty;
    //   this.setState({
    //     subLocations: qtyData,
    //   });
    // }

    // new added by jay
    if (nextProps.balance/* && JSON.stringify(nextProps.balance) !== JSON.stringify(nextProps.balance)*/) {
      const qtyData = [...this.state.subLocations];
      // console.log(qtyData);
      qtyData[this.state.currentIndex] = nextProps.balance;
      this.setState({
        subLocations: qtyData,
      });
    }
  }

  removeSpare = (index, boxIndex) => {
    const { keys, selectedSpares } = this.state;
    const { form, filters } = this.props;
    const item = filters ? filters['spares'] : {};
    if (keys.length === 1) {
      return;
    }
    const val = form.getFieldValue('spares');
    val.splice(boxIndex, 1);
    keys.splice(boxIndex, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((itm) => {
        form.setFieldsValue({
          [`spares[${i}]['${itm}']`]: val[i][itm],
        });
      });
    }

    // Rebuild selectedSpares with updated indices after removal
    const newSelectedSpares = {};
    Object.keys(selectedSpares).forEach(key => {
      const keyIndex = parseInt(key);
      if (keyIndex < boxIndex) {
        newSelectedSpares[keyIndex] = selectedSpares[key];
      } else if (keyIndex > boxIndex) {
        newSelectedSpares[keyIndex - 1] = selectedSpares[key];
      }
    });

    const arr = [...this.state.subLocations];
    arr[index] = [];
    this.setState({
      keys: keys,
      subLocations: arr,
      selectedSpares: newSelectedSpares
    });
  };

  addSpare = () => {
    const { keys } = this.state;
    keys.push({});
    this.setState({
      keys: keys,
    });
  };

  getExcludedSpareIds = (index) => {
    const { selectedSpares } = this.state;
    const excludedIds = [];
    Object.keys(selectedSpares).forEach(key => {
      if (parseInt(key) !== index && selectedSpares[key]) {
        excludedIds.push(selectedSpares[key]);
      }
    });
    return excludedIds;
  }

  handleSpareSelect = (value, index) => {
    this.setState(prevState => ({
      selectedSpares: {
        ...prevState.selectedSpares,
        [index]: value
      }
    }));
  }

  onSpareSelect = (index, spareNameId) => {
    const { searchedData, form } = this.props;
    const searchPool = [...(this.state.spareSearchResults || []), ...(searchedData || [])];
    const spareName = searchPool.find(item => JSON.stringify(item._id) === JSON.stringify(spareNameId));
    const unitOfMeasurementId = spareName && spareName.unitOfMeasurement && spareName.unitOfMeasurement._id
      ? spareName.unitOfMeasurement._id
      : (spareName && spareName.unitOfMeasurementId ? spareName.unitOfMeasurementId : null);
    if (unitOfMeasurementId) {
      form.setFieldsValue({
        [`spares[${index}]['unitOfMeasurement']`]: unitOfMeasurementId,
      });
    }
    let data = {};
    data.location = this.state.location;
    // data.locationId = this.state.locationId;
    data.spare = spareNameId;
    if (data.location && data.spare) {
      const selectedDate = form.getFieldValue('date');
      this.props.getSpareInventoryBalance({
        spare: spareNameId,
        location: this.state.locationId,
        date: selectedDate ? moment(selectedDate).endOf('day').valueOf() : moment().endOf('day').valueOf(),
      });
      // this.props.getQuantity(data);
    }
    // Track the selected spare to prevent duplicates
    this.handleSpareSelect(spareNameId, index);
    this.setState({ currentIndex: index });
  };

  // Shows balance as on issue date: selected sub location only, or all sub locations of the location
  showBalancePopup = async (index) => {
    const { form } = this.props;
    const { locationId, selectedSpares } = this.state;
    const spareId = selectedSpares[index];
    if (!spareId || !locationId) {
      return;
    }

    const selectedDate = form.getFieldValue('date');
    const date = selectedDate ? moment(selectedDate).endOf('day') : moment().endOf('day');
    const subLocation = form.getFieldValue(`spares[${index}]['jobCardSubLocation']`);

    const popup = {
      visible: true,
      loading: true,
      rows: [],
      date,
      hasSubLocation: !!subLocation,
    };
    this.balancePopupRequest = popup;
    // Fetched balance also refreshes this row's Sub Location options (see componentWillReceiveProps)
    this.setState({ balancePopup: popup, currentIndex: index });

    let rows = [];
    try {
      const balance = await this.props.getSpareInventoryBalance({
        spare: spareId,
        location: locationId,
        date: date.valueOf(),
      });
      const selectedId = subLocation === 'NA' ? null : subLocation;
      rows = (balance || []).filter(item => !subLocation || (item._id || null) === selectedId);
    } catch (error) {
      // error message is already shown by the action
    }

    if (this.balancePopupRequest === popup) {
      this.setState({ balancePopup: { ...popup, loading: false, rows } });
    }
  };

  closeBalancePopup = () => {
    this.balancePopupRequest = null;
    this.setState({ balancePopup: { visible: false, loading: false, rows: [] } });
  };

  renderBalancePopup() {
    const { balancePopup } = this.state;
    const rows = balancePopup.rows || [];
    const total = rows.reduce((sum, row) => sum + (parseFloat(row.total) || 0), 0);
    const columns = [
      {
        title: 'Sub Location',
        dataIndex: 'name',
        key: 'name',
        render: (name, row) => (row._id ? name : 'No Sub Location'),
      },
      { title: 'Balance', dataIndex: 'total', key: 'total', align: 'right' },
    ];

    return (
      <Modal
        title={`Balance as on ${balancePopup.date ? moment(balancePopup.date).format('DD-MM-YYYY') : ''}`}
        visible={balancePopup.visible}
        onCancel={this.closeBalancePopup}
        footer={null}
        width={420}
        destroyOnClose
      >
        <Table
          size="small"
          rowKey={row => row._id || 'no-sub-location'}
          columns={columns}
          dataSource={rows}
          loading={balancePopup.loading}
          pagination={false}
          locale={{ emptyText: 'No balance found' }}
          footer={!balancePopup.hasSubLocation && rows.length > 1 ? () => <b>Total: {total}</b> : undefined}
        />
      </Modal>
    );
  }

  fetchOptimizedSpares = async (searchValue) => {
    const normalized = (searchValue || "").toString().trim();
    if (!normalized || normalized.length < 2) {
      this.spareSearchRequestSeq += 1;
      this.setState({ spareSearchResults: [] });
      return;
    }
    const requestSeq = ++this.spareSearchRequestSeq;
    try {
      const response = await axios.get(
        `/spare-part/search-spares?searchValue=${encodeURIComponent(normalized)}`,
      );
      if (requestSeq !== this.spareSearchRequestSeq) {
        return;
      }
      this.setState({
        spareSearchResults: (response && response.data) || [],
      });
    } catch (error) {
      if (requestSeq !== this.spareSearchRequestSeq) {
        return;
      }
      this.setState({ spareSearchResults: [] });
    }
  };

  spareFormItems() {
    const { data, form, filters, assetsList, resource, title, uomData } = this.props;
    const { getFieldDecorator, setFieldsValue } = form;
    const { keys } = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };
    return keys && isArray(keys) && keys.map((k, index) => {
      // Get excluded spare IDs to prevent duplicate selection
      const excludedIds = this.getExcludedSpareIds(index);

      return <div key={index} style={style}>
        <FieldSearchForm
          title={title}
          otherDetails={{}}
          options={filters && filters['spares'] && filters['spares']['schema']['spareName'].options}
          key={`spares[${index}]['spareName']`}
          name={`spares[${index}]['spareName']`}
          label={
            <span>Spare Name&nbsp;
              <Tooltip title="View balance as on issue date">
                <Button
                  size="small"
                  icon="eye"
                  style={{ marginBottom: 0 }}
                  disabled={!this.state.locationId || !this.state.selectedSpares[index]}
                  onClick={() => this.showBalancePopup(index)}
                />
              </Tooltip>
            </span>
          }
          message={`Spare Name is required`}
          required={true}
          disabled={this.state.jobCardSelected}
          field={'name'}
          model={'SparePart'}
          onSelect={this.onSpareSelect.bind(this, index)}
          initialValue={data && data['spares'] && data['spares'][index] && data['spares'][index]['spareName']}
          getFieldDecorator={getFieldDecorator}
          setFieldsValue={(setFieldsValue)}
          customSearch={this.fetchOptimizedSpares}
          searchDataOverride={this.state.spareSearchResults}
          minSearchLength={2}
          excludedIds={excludedIds}
          formIndex={index}
        />

        <Form.Item key={`${index}6`} label={'Unit of measurement'}>
          {
            getFieldDecorator(`spares[${index}]['unitOfMeasurement']`, {
              rules: [{ required: false, message: `Unit Of Measurement is required!` }],
              initialValue: data && data.spares && data.spares.length && data.spares[index] && data.spares[index].unitOfMeasurement && data.spares[index].unitOfMeasurement._id || '',
            })(<Select
              showSearch
              allowClear
              mode="single"
              style={{ width: '100%' }}
              placeholder="Please Select Unit Of Measurement"
              disabled
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {uomData && uomData.map(item =>
                <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
            </Select>)
          }
        </Form.Item>

        <Form.Item key={`${index}3`} label={'Units'}>
          {getFieldDecorator(`spares[${index}]['units']`, {
            rules: [{ required: true, message: `Units is required!` }],
            initialValue: data.spares && data.spares[index] && data.spares[index]['units'],
          })(<Input type='number'
            disabled={title === 'EDIT'}
            placeholder={'Units'}
            style={{ marginRight: 8 }}
            onWheel={event => event.currentTarget.blur()}
          />)
          }
        </Form.Item>

        <Form.Item key={`${index}4`} label={'Job Card Location'}>
          {getFieldDecorator(`spares[${index}]['jobCardLocation']`, {
            initialValue: title === 'CREATE' ? this.state.location : data.spares && data.spares[index] && data.spares[index]['jobCardLocation'],
          })(<Select disabled={true} style={{ marginRight: 8 }} />)
          }
        </Form.Item>

        <Form.Item key={`${index}5`} label={'Sub Location'}>
          {getFieldDecorator(`spares[${index}]['jobCardSubLocation']`, {
            rules: [{ required: true, message: `Sub Location is required!` }],
            initialValue: data.spares && data.spares[index] && data.spares[index]['jobCardSubLocation'] && data.spares[index]['jobCardSubLocation'].name,
          })(<Select style={{ marginRight: 8 }}
            showSearch
            allowClear
            mode="single"
            placeholder="Please Select Sub Location"
            disabled={title === 'EDIT'}>
            {
              this.state.subLocations && this.state.subLocations.length && this.state.subLocations[index] && this.state.subLocations[index].map(item =>
                <Select.Option key={`${item._id}${index}`}
                  value={item._id === null ? 'NA' : item._id}>{item && item._id === null ? 'No Sub Location' : item.name} | {item.total} </Select.Option>)}
          </Select>)
          }
        </Form.Item>

        {(title !== 'EDIT' && index > 0) ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.removeSpare(`${k}`, index)}
          />
        ) : null}
      </div>
    });
  }

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      // Always persist SPI date as end of selected day.
      if (values && values.date) {
        values.date = moment(values.date).endOf('day').toISOString();
      }

      values && values['spares'] && values['spares'].length && values['spares'].map(item => {
        if (item && item['jobCardSubLocation'] && item['jobCardSubLocation'] === 'NA') {
          item['jobCardSubLocation'] = null;
        }
      });

      if (match.params && match.params.id) {
        this.props.onSubmit({ ...values, ...{ balance: this.state.subLocations } }, match.params.id);
      } else {
        this.props.onSubmit({ ...values, ...{ balance: this.state.subLocations } });
      }
    });
  };

  clearSparesData = () => {
    const { form, filters } = this.props;
    const item = filters ? filters['spares'] : {};

    // Reset spares form fields
    if (item && item.schema) {
      Object.keys(item.schema).forEach((fieldName) => {
        form.setFieldsValue({
          [`spares[0]['${fieldName}']`]: undefined,
        });
      });
    }

    // Reset state to single empty spare entry
    this.setState({
      keys: [{}],
      selectedSpares: {},
      subLocations: [],
      currentIndex: '',
    });
  }

  handleLocationChange = (name, id) => {
    this.props.form.setFieldsValue({ jobCard: '' });
    this.setState({ location: name, locationId: id });
    // Clear spares when location changes
    this.clearSparesData();
  }

  handleJobClick = () => {
    this.setState({ jobCardSelected: false });
    // Clear spares when job card changes
    this.clearSparesData();
  }

  handleDateChange = (date) => {
    // Clear spares when date changes
    this.clearSparesData();
  }

  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    const {
      data,
      loading,
      filters,
      title,
      resource,
      form,
      allLocation,
      jobCardData,
      spareNameData,
      searchedData
    } = this.props;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {
              title === 'CREATE' && <Form.Item key={'location'} label={'Search Location'}>
                {getFieldDecorator(`location`, {
                  rules: [{ required: true, message: `Location is required!` }],
                  initialValue: '',
                })(<Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                  }
                  onSelect={this.props.getJobCardData}
                  placeholder={'ex. abc'}>
                  {
                    allLocation && allLocation.map((item) => {
                      return <Select.Option key={item._id} value={item._id} onClick={(name) => {
                        this.handleLocationChange(item.name, item._id)
                      }}>{item.name}</Select.Option>
                    })
                  }
                </Select>)}
              </Form.Item>
            }

            <Form.Item key={`jobCard`} label={'Job Card No'}>
              {getFieldDecorator(`jobCard`, {
                rules: [{ required: true, message: `Job Card is required!` }],
                initialValue: data && data.jobCard && data.jobCard['jobCardNo'],
              })(<Select
                disabled={title === 'EDIT'}
                showSearch
                style={{ width: '100%' }}
                placeholder="Please select"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {jobCardData && jobCardData && jobCardData.length > 0 && jobCardData.filter(item => item.status === 'Open').map(item =>
                  <Select.Option key={item._id} value={item._id} onClick={
                    this.handleJobClick}>{item['jobCardNo']}</Select.Option>)}
              </Select>)}
            </Form.Item>
            {
              title === 'EDIT' ?
                <Form.Item key={`spareIssueNo`} label={'Spare Issue No'}>
                  {getFieldDecorator(`spareIssueNo`, {
                    initialValue: data && data.spareIssueNo,
                  })(<Input
                    disabled
                    style={{ width: '100%' }}
                    placeholder="SPI"
                  />)}
                </Form.Item> : ''
            }

            <Form.Item key={`date`} label={'Date'}>
              {getFieldDecorator(`date`, {
                rules: [{ required: true, message: `date is required!` }],
                initialValue: data && data.date && moment(data.date),
              })(<DatePicker
                disabled={title === 'EDIT'}
                style={{ width: '100%' }}
                onChange={this.handleDateChange}
              />)}
            </Form.Item>
            {/*{filters && Object.keys(filters).map((item) => {*/}
            {/*if(item === 'date' || item === 'spareIssueNo') {*/}
            {/*return getFormFieldByType(filters, item, getFieldDecorator, data, {*/}
            {/*resource, title, setFieldsValue, disabledDate(current) {*/}
            {/*return current && current > moment().endOf('day');*/}
            {/*}*/}
            {/*})*/}
            {/*}*/}
            {/*})}*/}
            <div className="sublist-section-label">Spares</div>
            {this.spareFormItems()}
            {
              this.props.title !== 'EDIT' ?
                <Button type="dashed" onClick={this.addSpare} style={{ width: '60%', marginTop: '15px' }}>
                  <Icon type="plus" /> Add Spares
                </Button> : <br />
            }

            <Form.Item>
              {
                this.props.title !== 'EDIT' ?
                  <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                    {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                  </Button> : ''
              }
            </Form.Item>
          </Form>
          {this.renderBalancePopup()}
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
